/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type Shipping_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"useShippingPrice_viewer">;
    readonly " $refType": "Shipping_viewer";
};
export type Shipping_viewer$data = Shipping_viewer;
export type Shipping_viewer$key = {
    readonly " $data"?: Shipping_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Shipping_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Shipping_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'ab2333da6383e01a01060ad3186865c5';
export default node;
